export default function removeActiveCampaignStyle() {
  if ($('._form_1').length) {
    $('._form_1').find('style, link').each(function() {
      $(this).remove()
    })
  }
}